import { PaxErrorPage } from "@ncino/pax-ui";
import { useNavigate } from "@tanstack/react-router";
import { useTranslation } from "@ncino/pax-ui";

export function NotFoundPage() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <PaxErrorPage
      header={t("pageNotFound.header")}
      subtext=""
      actionLabel={t("pageNotFound.actionLabel")}
      onAction={() => navigate({ to: "/" })}
    />
  );
}
